import {Button, Card, Form, Placeholder, Spinner} from 'react-bootstrap'
import {FormattedMessage, useIntl} from 'react-intl'

const paginationPlaceholder = '1/ -'

export const LoadingLeadsPage = () => {
  const intl = useIntl()
  return (
    <div className='d-flex flex-column w-100'>
      <div className='w-100 mb-4 d-flex justify-content-between flex-column flex-md-row gap-4'>
        <div className='d-flex gap-2'>
          <Form.Select
            aria-label={intl.formatMessage({id: 'leads.list.pipeline', defaultMessage: 'Pipeline'})}
            disabled
          >
            <option>{intl.formatMessage({id: 'leads.list.pipeline', defaultMessage: 'Pipeline'})}</option>
          </Form.Select>
          <Form.Select size='sm' disabled>
            <option>
              {intl.formatMessage({
                id: 'leads.list.viewActiveStages',
                defaultMessage: 'View active stages',
              })}
            </option>
          </Form.Select>
        </div>
        <div>
          <Button
            id='dropdown-basic-button'
            title={intl.formatMessage({id: 'leads.list.addTooltip', defaultMessage: '+ Add'})}
            disabled
          >
            <i className='bi bi-person-vcard' />
            <FormattedMessage id='leads.list.addLead' defaultMessage='Add lead' />
          </Button>
        </div>
      </div>
      <div className='d-flex gap-2 container-draggs' style={{maxWidth: '100%', overflowX: 'auto'}}>
        {[1, 2, 3, 4].map((el, ind) => (
          <Card
            key={el}
            style={{
              background: 'white',
              padding: 8,
              width: 250,
              flex: '1 0 250px',
            }}
          >
            <div
              style={{borderBottom: '1px solid #f1f1f2'}}
              className='px-3 py-2 d-flex align-items-center justify-content-between'
            >
              <Card.Title style={{width: '94px'}}>
                <Placeholder animation='wave'>
                  <Placeholder xs={12} />
                </Placeholder>
              </Card.Title>
              <div>
                <span
                  className='d-flex align-items-center justify-content-center px-3 py-1 text-primary'
                  style={{
                    borderRadius: '20px',
                    backgroundColor: '#f6f7fb',
                  }}
                >
                  <Spinner animation='border' size='sm' />
                </span>
              </div>
            </div>
            <div style={{borderBottom: '1px solid #f1f1f2'}} className='px-3 py-2 pb-2 mb-4'>
              <div className='d-flex align-items-center justify-content-between w-100'>
                <div>
                  <Form.Select size='sm' className='border-0' style={{color: 'gray'}}>
                    <option>
                      {intl.formatMessage({
                        id: 'common.placeholder.selectOption',
                        defaultMessage: 'Select an option',
                      })}
                    </option>
                  </Form.Select>
                </div>
                <div>
                  <div className='d-flex align-items-center gap-3'>
                    <button className='m-0 p-0 border-0 bg-transparent '>
                      <i className='bi bi-arrow-left' />
                    </button>
                    <span className='text-secondary'>{paginationPlaceholder}</span>
                    <button className='m-0 p-0 border-0 bg-transparent'>
                      <i className='bi bi-arrow-right' />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <Card.Body
              className='placeholder-glow p-0 mb-1'
              style={{maxHeight: '100%', overflowY: 'auto'}}
            >
              {[1, 2, 3, 4, 5].map((m) => (
                <Card
                  key={m}
                  className='placeholder'
                  style={{
                    padding: 8 * 2,
                    margin: `0 0 ${8}px 0`,
                    background: '#c4c4c4',
                    height: `${80 + (Math.floor(Math.random() * 10) % 2 === 0 ? 20 : 0)}px`,
                    display: 'block',
                  }}
                ></Card>
              ))}
            </Card.Body>
          </Card>
        ))}
      </div>
    </div>
  )
}
